import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpErrorResponse, HttpEventType } from  '@angular/common/http';  
import { environment } from '../../environments/environment';
import { User } from '../_models';
import { observable, Observable,of } from 'rxjs';
import { map } from  'rxjs/operators';
import { String } from 'typescript-string-operations';
import { RootService } from './root.service';

@Injectable({
    providedIn: 'root'
  })
  export class UserService {
  
    BaseURI : string ;
    constructor(private http: HttpClient,private rootService : RootService) { 
        this.BaseURI =  this.rootService.GetBaseURL();
    }
        
    register(param) {       
      return this.http.post(this.BaseURI + '/Auth/registration', param);
    }
    
    getAllCustomers(status : string){      
      return this.http.get<any>(String.Format(this.BaseURI + '/Admin/get-all-customers/{0}', status)).pipe(map( res => <any>res));
    }

    getCusomerDetail(userId){
      return this.http.get<any>(String.Format(this.BaseURI + '/Admin/get-customer-detail/{0}', userId)).pipe(map( res => <any>res));
    }

    getUserDetail(userId){
      return this.http.get<any>(String.Format(this.BaseURI + '/Admin/get-user-detail/{0}', userId)).pipe(map( res => <any>res));
    }

    updateCustomer(param) {             
      return this.http.put(this.BaseURI + '/Admin/update-customer', param);
    }

    updateUser(param) {             
      return this.http.put(this.BaseURI + '/Admin/update-user', param);
    }
      
    DeActivateUser(userId) {             
      let param = {
        Id : userId
      }
      return this.http.put(this.BaseURI + '/Admin/deactivate-customer', param);
    }
    ActivateUsersub(userId) {             
      let param = {
        Id : userId
      }
      // console.log('true');
      return this.http.put(this.BaseURI + '/Admin/activate-customer-sub', param);
    }
    DeactivateUsersub(userId){
      let param = {
        Id : userId
      }
      // console.log('true');
      return this.http.put(this.BaseURI + '/Admin/deactivate-customer-sub', param);
    }
    DeleteUser(userId) {    
      let param = {
        Id : userId
      }   
      return this.http.put(this.BaseURI + '/Admin/delete-customer', param);
    }

    getAllUsers(status : string, role:string){      
      return this.http.get<any>(String.Format(this.BaseURI + '/Admin/get-all-users/{0}/{1}', status,role)).pipe(map( res => <any>res));
    }
  }
  